import { liveFeedbackStartedAtom, liveFeedbackWaitingToStartAtom } from '@realtime';
import { useMutation } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { apiClient, ApiConfig } from '@data';
import { queryClient, useLiveAnalysisEnabled } from '@queries';
import { Box, Button, u } from '@ui';

export const LiveAnalysisControls = () => {
    const { data: { enabled: liveAnalysisEnabled } = {} } = useLiveAnalysisEnabled();
    const { mutateAsync: startLiveAnalysis } = useMutation({
        mutationFn: () => apiClient.post(ApiConfig.path('/api/v1/live-feedback/tare')),
    });

    const { mutateAsync: stopLiveAnalysis } = useMutation({
        mutationFn: () => apiClient.post(ApiConfig.path('/api/v1/live-feedback/reset')),
    });

    const { mutateAsync: disableLiveAnalysis } = useMutation({
        mutationFn: () => apiClient.put(ApiConfig.path('/api/v1/live-feedback/enabled'), { enabled: false }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['live-feedback', 'enabled'] });
        },
    });
    const isWaitingToStart = useAtomValue(liveFeedbackWaitingToStartAtom);
    const isStarted = useAtomValue(liveFeedbackStartedAtom);

    return (
        <Box display="flex" gap={u(1)} justifyContent={'space-between'}>
            <Box display="flex" gap={u(1)}>
                <Button
                    onClick={() => startLiveAnalysis()}
                    variant={isWaitingToStart ? 'primary' : 'secondary'}
                    isDisabled={!liveAnalysisEnabled}
                    rounded
                    icon="play"
                >
                    Start
                </Button>
                <Button
                    onClick={() => stopLiveAnalysis()}
                    variant={isStarted ? 'primary' : 'secondary'}
                    isDisabled={!liveAnalysisEnabled}
                    rounded
                    icon="pause"
                >
                    Stop
                </Button>
            </Box>
            <Button
                onClick={() => disableLiveAnalysis()}
                variant={liveAnalysisEnabled ? 'destroy' : 'secondary'}
                isDisabled={!liveAnalysisEnabled}
                rounded
                icon="close"
            >
                Exit Live
            </Button>
        </Box>
    );
};
